import { createReducer } from '@reduxjs/toolkit';

import {
  loadPayoutOrderItemStart,
  loadPayoutOrderItemSuccess,
  loadPayoutOrderListSuccess,
  loadPayoutOrderStart,
  resetPayoutOrderItem,
} from './actions';
import { IPayoutOrderReducer } from './types';

const initialState: IPayoutOrderReducer = {
  list: {
    isLoading: false,
    isLoaded: false,
    data: {},
  },
  item: {
    isLoading: false,
    isLoaded: false,
    data: {},
  },
};

const PayoutOrderReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadPayoutOrderStart, (state) => ({
      ...state,
      list: {
        ...state.list,
        isLoading: true,
      },
    }))
    .addCase(loadPayoutOrderListSuccess, (state, action) => ({
      ...state,
      list: { ...state.list, isLoading: false, isLoaded: true, data: action.payload },
    }))
    .addCase(loadPayoutOrderItemStart, (state) => ({
      ...state,
      item: {
        ...state.item,
        isLoading: true,
      },
    }))
    .addCase(loadPayoutOrderItemSuccess, (state, action) => ({
      ...state,
      item: {
        ...state.item,
        isLoading: false,
        isLoaded: true,
        data: action.payload,
      },
    }))
    .addCase(resetPayoutOrderItem, (state) => ({
      ...state,
      item: {
        isLoading: false,
        isLoaded: false,
        data: {},
      },
    }));
});

export default PayoutOrderReducer;
